import axios from 'axios'
// import store from '../store'

// const apiHeaders = store.state.auth.state.token ? { Authorization: `Bearer` } : {}

const apiCall = async (apiPath, method, data) =>
  axios({
    method,
    url: `${process.env.VUE_APP_API_BASEURL}${apiPath}`,
    // headers: apiHeaders,
    data
  })
    .then(response => response)
    .catch(err => {
      console.error(`Error response from ${err.config.url}: ${err.response.status} - ${err.response.data}`)
      throw err.response
    })

export default apiCall
